var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vaadin:shop",
    clipPath: "url(#clip0_1427_1188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.774414 88.12H94.7691V93.9947H0.774414V88.12ZM0.774414 0V35.248C0.803787 39.5483 3.13016 43.2963 6.59621 45.3231L6.64908 82.2454H59.5211V52.872H77.1451V82.2454H88.8945V45.3524C92.4134 43.2963 94.7398 39.5483 94.7691 35.2539V0H0.774414ZM24.2731 11.7493H36.0224V35.248C36.0224 36.8061 35.4035 38.3003 34.3018 39.402C33.2001 40.5037 31.7058 41.1227 30.1478 41.1227C28.5897 41.1227 27.0955 40.5037 25.9937 39.402C24.892 38.3003 24.2731 36.8061 24.2731 35.248V11.7493ZM12.5238 41.1227C10.9657 41.1227 9.47145 40.5037 8.36973 39.402C7.26802 38.3003 6.64908 36.8061 6.64908 35.248V11.7493H18.3984V35.248C18.3984 36.8061 17.7795 38.3003 16.6778 39.402C15.5761 40.5037 14.0818 41.1227 12.5238 41.1227ZM47.7718 70.496H18.3984V52.872H47.7718V70.496ZM53.6464 35.248C53.6464 36.8061 53.0275 38.3003 51.9258 39.402C50.8241 40.5037 49.3298 41.1227 47.7718 41.1227C46.2137 41.1227 44.7195 40.5037 43.6178 39.402C42.516 38.3003 41.8971 36.8061 41.8971 35.248V11.7493H53.6464V35.248ZM71.2704 35.248C71.2704 36.8061 70.6515 38.3003 69.5498 39.402C68.4481 40.5037 66.9538 41.1227 65.3958 41.1227C63.8377 41.1227 62.3435 40.5037 61.2418 39.402C60.14 38.3003 59.5211 36.8061 59.5211 35.248V11.7493H71.2704V35.248ZM88.8945 35.248C88.8945 36.8061 88.2755 38.3003 87.1738 39.402C86.0721 40.5037 84.5779 41.1227 83.0198 41.1227C81.4617 41.1227 79.9675 40.5037 78.8658 39.402C77.7641 38.3003 77.1451 36.8061 77.1451 35.248V11.7493H88.8945V35.248Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1427_1188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.9947,
    height: 93.9947,
    fill: "white",
    transform: "translate(0.774414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopDoodle);
export default __webpack_public_path__ + "static/media/shopDoodle.09044984086291eea1597888b2603e2f.svg";
export { ForwardRef as ReactComponent };